import formStyles from "../../styles/formPage.module.scss";

/**
 * Rendered in place of a lazily-loaded page/tool whose chunk failed to load — almost always
 * because a new version was deployed and the old content-hashed chunk no longer exists.
 * Lets the lazy loader resolve gracefully (no throw → no "Something went wrong" boundary);
 * the global UpdateBanner is also flagged so the user is prompted to reload.
 */
export function ChunkUnavailable() {
  return (
    <div style={{ padding: "var(--space-6)", textAlign: "center", color: "var(--color-text-secondary)" }}>
      <p style={{ marginBottom: "var(--space-3)", fontSize: "var(--text-sm)" }}>
        This section couldn’t load — a new version was deployed since you opened the page.
      </p>
      <button className={formStyles.primaryBtn} onClick={() => window.location.reload()}>
        Reload to continue
      </button>
    </div>
  );
}
